import React from "react";
import * as finService from "../../../services/finService";
import useFinOptions from "../useFinOptions";
import { FormDrawer, todayYmd, useLoad } from "../../../components/ui";

// Money received from a customer: cash (through your open drawer), card, transfer, cheque or PDC.
// fixed: values the caller decides (customer, purpose, source document) - those fields are hidden.
// save(body): defaults to creating a Finance receipt; the order advance passes its own call.
export default function ReceiptForm({ show, onHide, onDone, fixed = {}, title = "Receive payment", save, defaultAmount, hideCustomer = false, hideLocation = false }) {
  const opts = useFinOptions(["receipt-methods", "locations", "bank-accounts"]);
  const noCustomer = hideCustomer || !!fixed.customer_account_id;
  const customers = useLoad(() => (noCustomer ? Promise.resolve({ success: true, data: [] }) : finService.listCustomers({ size: 200 })), [noCustomer]);
  const methods = opts["receipt-methods"] || [];
  const typeOf = (id) => ((methods.find((m) => m.value === id) || {}).row || {}).method_type;
  return (
    <FormDrawer
      show={show}
      title={title}
      initial={{ receipt_date: todayYmd(), auto_apply: true, amount: defaultAmount ?? "", cheque_date: todayYmd() }}
      onHide={onHide}
      onDone={onDone}
      width={560}
      onSave={(clean, raw) => {
        const t = typeOf(raw.method_id);
        const body = {
          ...fixed,
          customer_account_id: fixed.customer_account_id || clean.customer_account_id,
          method_id: clean.method_id,
          amount: Number(clean.amount),
          receipt_date: clean.receipt_date,
          location_id: fixed.location_id || clean.location_id,
          reference: clean.reference,
          bank_account_id: clean.bank_account_id,
          auto_apply: fixed.purpose === "ADVANCE" ? undefined : !!raw.auto_apply,
          remarks: clean.remarks,
          cheque: ["CHEQUE", "PDC"].includes(t) ? { cheque_number: clean.cheque_number, drawee_bank: clean.drawee_bank, cheque_date: clean.cheque_date } : undefined,
        };
        return save ? save(body) : finService.createReceipt(body);
      }}
      fields={(v) => {
        const t = typeOf(v.method_id);
        return [
          ...(noCustomer ? [] : [{ key: "customer_account_id", label: "Customer", type: "select", required: true, options: (customers.data || []).map((c) => ({ label: `${c.name} (${c.account_number})`, value: c.id })) }]),
          ...(fixed.location_id || hideLocation ? [] : [{ key: "location_id", label: "Location", type: "select", options: opts.locations || [] }]),
          { key: "method_id", label: "Paid by", type: "select", required: true, options: methods },
          { key: "amount", label: "Amount", type: "number", step: "any", min: 0, required: true },
          { key: "receipt_date", label: "Date", type: "date", required: true },
          ...(["CHEQUE", "PDC"].includes(t)
            ? [
                { key: "cheque_number", label: "Cheque number", required: true, max: 30 },
                { key: "drawee_bank", label: "Bank of the cheque", required: true, max: 100 },
                { key: "cheque_date", label: t === "PDC" ? "Cheque date (when it can be deposited)" : "Cheque date", type: "date", required: true },
              ]
            : [{ key: "reference", label: t === "CARD" ? "Card authorisation" : t === "BANK_TRANSFER" ? "Transfer reference" : "Reference", max: 60 }]),
          ...(t === "BANK_TRANSFER" ? [{ key: "bank_account_id", label: "Received in (blank: the method's account)", type: "select", options: opts["bank-accounts"] || [] }] : []),
          ...(fixed.purpose === "ADVANCE" ? [] : [{ key: "auto_apply", label: "Apply to the oldest open invoices", type: "checkbox" }]),
          { key: "remarks", label: "Remarks", type: "textarea", max: 500 },
        ];
      }}
    />
  );
}
